import { HomeSchoolFormPage } from './HomeSchoolFormPage';
export default HomeSchoolFormPage;
